import { Route, Routes } from "react-router-dom"
import AuthOtpConfirmation from "../../pages/AuthOtpConfirmation"

const AuthFlow = () => (
  <Routes>
    <Route index element={<AuthOtpConfirmation />} />
  </Routes>
)

export default AuthFlow
